import gql from "graphql-tag";

export const SET_USER_NOTIFICATIONS_SEEN = gql`
  mutation ($ids: [Int!]!) {
    setUserNotificationsSeen(data: { ids: $ids })
  }
`;
